import { render, staticRenderFns } from "./AssignmentImportConfirm.vue?vue&type=template&id=5289fc0d&scoped=true"
import script from "./AssignmentImportConfirm.vue?vue&type=script&lang=ts"
export * from "./AssignmentImportConfirm.vue?vue&type=script&lang=ts"
import style0 from "./AssignmentImportConfirm.vue?vue&type=style&index=0&id=5289fc0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5289fc0d",
  null
  
)

export default component.exports